<template>
  <svg
    width="18"
    height="17"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 17"
  >
    <path
      d="M2.412 1.412L15.69 14.69m-.102-13.278L2.31 14.69"
      stroke-width="2"
      stroke="#313345"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="square"
    />
  </svg>
</template>

<script>
export default {
  name: 'CrossIcon'
}
</script>



// WEBPACK FOOTER //
// src/components/icons/CrossIcon.vue